<template>
  <div class="invite-template" v-if="business || errors.length">
    <div class="invite-hero">
      <div v-if="business">
        <div class="container">
          <img class="invite-hero__logo" :src="business.avatar.url_sm" />
          <div class="invite-hero__business">{{ business.name }}</div>
          <h1>Customer Portal</h1>
          <p>
            Welcome to the customer portal that gives you access to your invoices, estimates, appointments.
          </p>
          <error :errors="errors"></error>
        </div>
        <div class="container">
          <div class="box box-app-ios" v-if="canInstallAppIos">
              To install the app on your phone: tap <img style="height: 30px; padding-bottom: 5px;" src="../assets/apple_share.png"> icon and then Add To  Home Screen.
          </div>
          <button class="btn btn-primary margin-right" v-if="canInstallApp" @click="installApp()">Install App</button>
          <router-link class="btn btn-primary" :to="{name: 'dashboard'}">Dashboard</router-link>
        </div>
      </div>
      <div v-else>
        <div class="container">
          <div class="errors-container">
            <h1>Customer Portal</h1>
            <p>
              Welcome to the customer portal that gives you access to your invoices, estimates, appointments.
            </p>
            <error :errors="errors"></error>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '@/lib/http';
import Error from '@/components/Error.vue';
import store from '@/store';

export default {
  name: 'home',
  props: {},
  components: {
    Error,
  },
  data() {
    return {
      business: null,
      config: null,
      canInstallApp: false,
      canInstallAppIos: false,
      deferredPrompt: null,
      isInStandaloneMode: false,
      errors: [],
    };
  },
  created() {
    // use a dynamic manifest
    const $manifest = document.querySelector('link[rel="manifest"]');
    const nextManifest = document.createElement('link');
    nextManifest.id = 'manifest';
    nextManifest.rel = 'manifest';
    nextManifest.href = `/api/v1/customer_portal/config/main/manifest/${this.$route.params.hash}`;
    $manifest.parentNode.replaceChild(nextManifest, $manifest);

    // listen only one time, because this event is triggred again after app is installed (accepted)
    // resetting the values
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstallApp = true;
    }, {
      once: true,
    });

    // if appinstalled
    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.canInstallApp = false;
    });

    // if launched as standalone usually after app install don't show the install button
    // window.addEventListener('DOMContentLoaded', () => {
    // const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator.standalone);
    this.isInStandaloneMode = navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
    if (this.isInStandaloneMode) {
      this.canInstallApp = false;
    }
    // });

    // for iOS show the Add to Home banner
    const isIos = () => {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    };
    if (isIos() && !this.isInStandaloneMode) {
      this.canInstallAppIos = true;
    }

    Http.post('auth/login/invite', {
      hash: this.$route.params.hash,
    }).then((response) => {
      // store
      store.commit('setBusiness', response.data.business);
      store.commit('setCustomer', response.data.customer);
      store.commit('setLocale', response.data.locale);
      store.commit('setAppVersion', response.data.config.app_version);

      // go directly to dashboard if in standalone mode
      if (this.isInStandaloneMode) {
        this.$router.push({ name: 'dashboard' });
        return;
      }

      // update UI
      this.business = response.data.business;
      this.config = response.data.config;

      // set icons
      const $appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
      $appleTouchIcon.href = this.config.apple_touch_icon;
    }).catch((error) => {
      if (error.response) {
        this.errors.push(error.response.data.error.message);
      }
    });
  },
  methods: {
    installApp() {
      if (!this.deferredPrompt) {
        return;
      }

      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          // user accepted the install prompt
          this.canInstallApp = false;
        } else {
          console.log('User dismissed the install prompt');
        }
      });
    },
  },
};
</script>

<style scoped>
.invite-template {
  background: #fff;
  height: 100vh;
  background: url('/assets/images/app/customer_portal/login_1.png') #fff no-repeat;
}

.invite-hero {
  width: 100%;
  min-height: 300px;
  background: url('/assets/images/app/customer_portal/login_2.png') top right no-repeat;
}
.invite-hero .container {
  padding-left: 20px;
  padding-right: 20px;
}
.invite-hero__logo {
  margin-top: 120px;
  width: 54px;
  height: 54px;
  border: 2px solid #eaeaea;
  border-radius: 50%;
  background: #e5eaea;
  margin-bottom: 20px;
}
.invite-hero h1 {
  font-size: 26px;
  font-weight: normal;
}
.invite-hero__business {
  font-size: 20px;
  color: #858585;
  margin-bottom: 5px;
}

.box-app-ios {
  background:#147efb;
  color: #fff;
  font-weight: 500;
}

.errors-container {
  padding-top: 200px;
}
</style>
